import React from 'react';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {FormCustomTabControlWrapperProps} from '@src/@types/components/Form';

export default function DefaultTabControlWrapper<Model extends IEmptyModel = IEmptyModel>(
        props: FormCustomTabControlWrapperProps<Model>
) {
    return <>{props.children}</>;
}
